import { FC, SVGProps } from 'react';
import { EntityChip, Icons } from '@silverfort/sf-components';
import { RISK_LEVELS } from '@silverfort-nodelibs/common/utils/consts';
import { capitalizeFirstLetter } from '@silverfort-nodelibs/common/utils/common';

const RISK_LABEL_BY_LEVEL = Object.values(RISK_LEVELS).reduce((acc, { value, label }) => {
    acc[value] = capitalizeFirstLetter(label);
    return acc;
}, {});

interface RiskChipProps {
    risk: number;
    className?: string;
}

const RiskChip: FC<RiskChipProps> = ({ risk, className }) => {
    const icon = risk === RISK_LEVELS.CRITICAL.value ? (Icons.Warning as FC<SVGProps<SVGSVGElement>>) : undefined;
    const iconClassName = risk === RISK_LEVELS.CRITICAL.value ? 'text-sf-negative-500' : '';
    return (
        <EntityChip className={className} text={RISK_LABEL_BY_LEVEL[risk]} icon={icon} iconClassName={iconClassName} />
    );
};

export default RiskChip;
